// extracted by mini-css-extract-plugin
export default {"sortIcon":"MyleTableColumn_sortIcon__cjtF8","columnClickableHeader":"MyleTableColumn_columnClickableHeader__jy1pz"};